import {ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Optional, Output} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";
import {FUIColorPair} from "./color-pair.model";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIColorPairControlComponent),
            multi: true
        }
    ],
    selector: "fui-color-pair-control",
    templateUrl: "./color-pair-control.component.html",
    standalone: false
})
export class FUIColorPairControlComponent extends FUIAbstractControl {
    @Input() okLabel: string = "fui.color-control.button.ok";
    @Input() resetLabel: string = "fui.color-control.button.reset";
    @Input() backgroundEditable: boolean = true;
    @Input() foregroundEditable: boolean = true;
    @Input() allowBackgroundAlpha: boolean = false;
    @Input() allowForegroundAlpha: boolean = false;
    @Input() showClearIcon: boolean = true;
    @Output() onClear: EventEmitter<void> = new EventEmitter<void>();
    @Input() backgroundSelected: boolean = true;
    @Output() backgroundSelectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
    }

    override valueEqual(value1: FUIColorPair, value2: FUIColorPair): boolean {
        if (value1 == undefined && value2 == undefined) {
            return true;
        }
        if (value1 == undefined || value2 == undefined) {
            return false;
        }
        return value1.backgroundColor === value2.backgroundColor && value1.foregroundColor === value2.foregroundColor;
    }

    get inputBackgroundSelected(): boolean {
        return this.backgroundSelected;
    }

    set inputBackgroundSelected(value: boolean) {
        this.backgroundSelected = value;
        this.backgroundSelectedChange.next(value);
    }
}
